import moment from 'moment-timezone'

moment.tz.setDefault('EST')

const { REACT_APP_API_URL = 'http://localhost:3001' } = process.env

export default {
  apiUrl: REACT_APP_API_URL,
}
